import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Card, Carousel } from 'react-bootstrap'
import AGSLogo from '../assets/Images/Ags Jb Logo-01-01.png'
import AparnaLogo from '../assets/Images/Aparna-Logo.png'
import APRLogo from '../assets/Images/APR-Group-Logo.jpg'
import ARKLogo from '../assets/Images/ARK-Group-Logo.png'
import GLOBALLogo from '../assets/Images/Global Mineral Works-01.png'
import GOWRAVENTURESLogo from '../assets/Images/gowra-logo-retina-Logo.png'
import JAINCONSTRUCTIONLogo from '../assets/Images/jain-constructions-logo.webp'
import NCLLogo from '../assets/Images/NCl-Logo.svg'
import NUVOCOLogo from '../assets/Images/Nuvoco-Logo.png'
import OMSREELogo from '../assets/Images/om.png'
import RAJAPUSHPALogo from '../assets/Images/Rajapushpa.png'
import SHAPOORJILogo from '../assets/Images/shapoorji-Logo.svg'
import SREEMAN from '../assets/Images/sreemanlogo.png'
import SRIAS from '../assets/Images/Srias-Life-Logo.png'
import GRINFRACON from '../assets/Images/unnamed.png'
import HellaInfra from '../assets/Images/inframarket-logo.png'
import Inventaa from '../assets/Images/Inventa-1-1-1.jpg'
import Kalapataru from '../assets/Images/KalpaTaru Logo-01.png'
import MYHOME from '../assets/Images/MyHome.png'
import Jaidhar from '../assets/Images/Jaidhar Logo-01-01.png'
import KMR from '../assets/Images/Kmr Logo-01.png'
import NJR from '../assets/Images/NJR Logo-01.png'
import Tellapur from '../assets/Images/Tellapur.jpg'
import VEDANTA from '../assets/Images/Vedanta Logo-01.png'
import SLE from '../assets/Images/SLE Logo-01.png'
import QUBEX from '../assets/Images/Qubex-01.png'
import '../css/Clients.css'

const clients = [
  { id: 1, name: 'SHAPOORJI PALLONJI AND COMPANY PRIVATE LIMITED', logo: SHAPOORJILogo },
  { id: 2, name: 'NUVOCO VISTAS CORPORATION LTD.', logo: NUVOCOLogo },
  { id: 3, name: 'NCL INDUSTRIES LIMITED', logo: NCLLogo },
  { id: 4, name: 'KALPATARU POWER TRANSMISSION LTD', logo: Kalapataru },
  { id: 5, name: 'HELLA INFRA MARKET PRIVATE LIMITED', logo: HellaInfra },
  { id: 6, name: 'APARNA CONSTRUCTIONS AND ESTATES PVT LTD', logo: AparnaLogo },
  { id: 7, name: 'MY HOME INFRASTRUCTURES PVT LTD.', logo: MYHOME },
  { id: 8, name: 'AGS & JB PROPERTIES', logo: AGSLogo },
  { id: 9, name: 'APR BUILDERS AND CONTRACTORS', logo: APRLogo },
  { id: 10, name: 'ARK BUILDERS', logo: ARKLogo },
  { id: 11, name: 'GLOBAL MINERAL WORKS', logo: GLOBALLogo },
  { id: 12, name: 'GOWRA VENTURES PRIVATE LIMITED', logo: GOWRAVENTURESLogo },
  { id: 13, name: 'JAIN CONSTRUCTIONS', logo: JAINCONSTRUCTIONLogo },
  { id: 14, name: 'OM SREE BUILDERS & DEVELOPERS', logo: OMSREELogo },
  { id: 15, name: 'SREEMAN CONSTRUCTIONS', logo: SREEMAN },
  { id: 16, name: 'RAJA PUSHPA PROPERTIES PRIVATE LIMITED', logo: RAJAPUSHPALogo },
  { id: 17, name: 'SRIAS LIFE SPACES LLP', logo: SRIAS },
  { id: 18, name: 'G R INFRACON PRIVATE LIMITED', logo: GRINFRACON },
  { id: 19, name: 'INVENTAA INDUSTRIES PRIVATE LIMITED', logo: Inventaa },
  { id: 20, name: 'JAIDHAR CONSTRUCTIONS', logo: Jaidhar },
  { id: 21, name: 'K M R ESTATES & BUILDERS PRIVATE LIMITED', logo: KMR },
  { id: 22, name: 'NJR CONSTRUCTIONS PRIVATE LIMITED.', logo: NJR },
  { id: 23, name: 'QUBEX SILICON INDUSTRIES', logo: QUBEX },
  { id: 24, name: 'SRI LAKSHMI ENTERPRISES', logo: SLE },
  { id: 25, name: 'TELLAPUR TECHNOCITY PRIVATE LIMITED', logo: Tellapur  },
  { id: 26, name: 'VEDANTA CONSTRUCTIONS', logo: VEDANTA  }
]

const Clients = ({ handleMenuItemHover }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth < 992) // lg breakpoint

    checkIsMobile()
    window.addEventListener('resize', checkIsMobile)
    return () => window.removeEventListener('resize', checkIsMobile)
  }, [])

  return (
    <div className='client'>
      <section className='section-wrap clients'>
        <div className='section clients'>
          <div className='section-cont clients'>
            <div  className='py-5 max-w-[90%] 2xl:max-w-[80%] mx-auto '>
              <h2
                className='text-[3.5rem] md:text-[6rem] lg:text-[6rem] lg:mt-[-72px] xl:mb-10 text-center mb-5'
                onMouseEnter={() => handleMenuItemHover(0)}
                onMouseLeave={() => handleMenuItemHover(null)}
              >
                Our Clients
              </h2>

              {isMobile ? (
                <Carousel interval={3000} indicators={false} controls={true}>
                  {clients.map(client => (
                    <Carousel.Item key={client.id}>
                      <div className='d-flex justify-content-center'>
                        <Card className='text-center shadow-sm border-0 ' style={{ width: '80%' }}>
                          <div
                            className='d-flex align-items-center justify-content-center'
                            style={{
                              height: '150px', 
                              paddingTop: '60px'
                            }}
                          >
                            {client.logo ? (
                              <Card.Img
                                variant='top'
                                src={client.logo}
                                alt={client.name}
                                style={{
                                  objectFit: 'contain',
                                  maxHeight: '100%',
                                  maxWidth: '80%',
                                  marginBottom: '60px'
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  color: '#fff',
                                  padding: '10px',
                                  fontWeight: 'bold',
                                  textAlign: 'center'
                                }}
                                className=''
                              >
                                {client.name}
                              </div>
                            )}
                          </div>
                          {/* <Card.Body>
                            <Card.Title className='text-muted text-center forSameFonts xl:text-[22px] md:text-[18px] text-[16px]'>
                              {client.name}
                            </Card.Title>
                          </Card.Body> */}
                        </Card>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              ) : (
                <Row className='g-4 gy-4'>
                  {clients.map(client => (
                    <Col key={client.id} xs={12} md={4} lg={3}>
                      <Card className='text-center shadow-sm border-0 h-100 d-flex flex-column '>
                        <div
                          className='d-flex align-items-center justify-content-center'
                          style={{
                            height: '150px',
                            paddingTop: '60px',
                            borderRadius:'50px'
                          }}
                        >
                          {client.logo ? (
                            <Card.Img
                              variant='top'
                              src={client.logo}
                               alt={client.name}
                              style={{
                                objectFit: 'contain',
                                maxHeight: '100%',
                                maxWidth: '80%',
                                marginBottom: '60px'
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                color: '#0079ba',
                                padding: '10px',
                                fontWeight: 'bold',
                                textAlign: 'center'
                              }}
                            >
                              {client.name}
                            </div>
                          )}
                        </div>
                        {/* <Card.Body className='d-flex align-items-center justify-content-center'>
                          <Card.Title className='text-muted text-center forSameFonts xl:text-[22px] md:text-[18px] text-[16px]'>
                            {client.name}
                          </Card.Title>
                        </Card.Body> */}
                      </Card>
                    </Col>
                  ))}
                </Row>
              )}
            </div>
            <div className='section-anim-trigger'></div>
          </div>
        </div>
      </section>
      <section className='section-spacer clients'></section>
    </div>
  )
}

export default Clients
